import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SetupEmail from './Pages/SetupEmail';
import SetupSMS from './Pages/SetupSMS';
import SetupInstagram from './Pages/SetupInstagram';
import SetupMetaAds from './Pages/SetupMetaAds';
const SetupChannelNew = () => {
  return (
    <>
      <Routes>
        <Route path="email" element={<SetupEmail />}></Route>
        <Route path="sms" element={<SetupSMS />}></Route>
        <Route path="instagram" element={<SetupInstagram />}></Route>
        <Route path='metaAds' element={<SetupMetaAds/>}></Route>
      </Routes>
    </>
  );
};

export default SetupChannelNew;
